import React from 'react'
import Container from '../components/Container'
import { ScrollFadeIn, ScrollFadeInStagger } from '../../../components/ScrollFadeIn'
import { TbChartHistogram, TbTagsOff } from 'react-icons/tb'

import { FaArrowsDownToPeople } from 'react-icons/fa6'
import GetStartedButton from '../components/GetStartedButton'


const items = [
    {
        // name: 'Misaligned Advisor Incentives',
        name_line_1: 'No More',
        description:
            'High commission products.',
        icon: TbTagsOff,
    },
    {
        // name: 'Minimum Investment Barriers',
        name_line_1: 'No More',
        description:
            'High fees eating away at your returns.',
        icon: TbChartHistogram,
    },
    {
        // name: 'Costly Management Fees',
        name_line_1: 'No More',
        description:
            'Getting turned away from advice for not having enough money.',
        icon: FaArrowsDownToPeople,
    },

]
const NoMore = () => {
    return (
        <Container bgColor='bg-gradient-to-bl from-sky-blue-200 via-primary-300 to-primary-500'>
            <ScrollFadeIn>
                <h3 className=" text-white text-center  heading-2 mx-auto max-w-4xl ">
                    Get Started Today!
                </h3>
            </ScrollFadeIn>
            <ScrollFadeInStagger className="grid lg:grid-cols-3 gap-16 mx-auto  justify-items-center mt-10 sm:mt-16">
                {items.map((item) => (
                    <ScrollFadeIn className='bg-white shadow-lg px-10 py-6 rounded-lg flex flex-col items-center space-y-4 w-full max-w-xs '>
                        <div className=" flex flex-col items-center">
                            <div className="bg-primary-800 h-12 w-12 text-white rounded-full flex justify-center items-center text-2xl font-lato">
                                <item.icon className='text-white h-7 w-7'

                                />
                            </div>
                            <p className="mt-3 heading-2 text-center max-w-[250px] text-primary-800">{item.name_line_1}</p>

                        </div>
                        <div className="bg-gradient-to-br from-sky-blue-200 via-primary-300 to-primary-500 h-1 w-full" />
                        <p className="body-1 text-center text-gray-600">
                            {item.description}

                        </p>
                    </ScrollFadeIn>
                ))}



            </ScrollFadeInStagger>

            <ScrollFadeIn className='mt-16 flex justify-center'>
             <GetStartedButton id='home-page-cta-2' />
            </ScrollFadeIn>

        </Container>)
}

export default NoMore